import { apiClient, handleResponse } from './axios';

async function getAll() {
  try {
    const response = await apiClient.get('/resources');
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function addNewResource(body) {
  try {
    const response = await apiClient.post('/resources', body);
    const resources = await handleResponse(response);
    return resources;
  } catch (error) {
    return error.response;
  }
}

async function deleteResource(id) {
  try {
    const response = await apiClient.delete(`/resources/${id}`);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function updateResource(id, body) {
  try {
    const response = await apiClient.put(`/resources/${id}`, body);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function getLanguage() {
  try {
    const response = await apiClient.get('/language/');
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function getCategorie() {
  try {
    const response = await apiClient.get('/category/');
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function addCategorie(body) {
  try {
    const response = await apiClient.post('/category/', body);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function deleteCategorie(catId) {
  try {
    const response = await apiClient.delete(`/category/${catId}`);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function getPresentationFiles() {
  try {
    const response = await apiClient.get('/resources/googlestorage/download');
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function uploadPresentationFile(file) {
  try {
    const res = await apiClient.post('/resources/googlestorage/upload', file);
    return res;
  } catch (error) {
    return error;
  }
}
async function deletePresentationFile(filename, company) {
  try {
    const res = await apiClient.post('/resources/googlestorage/delete', { filename, company });
    return res;
  } catch (error) {
    return error;
  }
}

const resourceServices = {
  getAll,
  addNewResource,
  deleteResource,
  updateResource,
  getLanguage,
  getCategorie,
  addCategorie,
  deleteCategorie,
  getPresentationFiles,
  uploadPresentationFile,
  deletePresentationFile,
};

export default resourceServices;
